import { InjectionToken } from '@angular/core';

export const REQUEST_SOURCE = new InjectionToken<string>('Request Source');
